
const LoadingTypes = {
  spinner: <div className="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>,
  spinner2: <div className="lds-spinner2"><div className="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div>,
  fb: <div className="text-center"><div className="lds-facebook"><div></div><div></div><div></div></div></div>,
  ring: <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
}
export const Loading = ({type}) => {
  return (LoadingTypes[type] || LoadingTypes['fb'])
}